import { agruparPedidos } from "./Index";
import { aFechaConDiagonales } from "../../tools/ConversionFechas";

  const handlePedidos = (e, id, pedidos, setPedidos, seleccionado, setModal) => {
    if( e.target.value > seleccionado.Cantidad ){
      setModal({
        show: true,
        ok: false,
        msg: "El valor ingresado no puede ser mayor al solicitado",
      })
    }else{
      let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
      let found = copiaPedidos.find(e => e.IdPedido === seleccionado.IdPedido)
      let cantidadValue = parseInt(e.target.value);
      if( cantidadValue > found.Productos[id]['CantidadPedido'] ){
        setModal({
          show:true,
          ok:false,
          msg:"No se puede ingresar una cantidad mayor a la solicitada"
        })
        found.Productos[id]['CantidadSaldo'] = ""; // Cantidad
        setPedidos(() => copiaPedidos);
      }else{
        found.Productos[id]['CantidadSaldo'] = cantidadValue; // Cantidad
        setPedidos(() => copiaPedidos);
      }
    }
  }
  
  
  const handleIdProdProv = (e, id, pedidos, setPedidos, seleccionado) => {
      let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
      let found = copiaPedidos.find(e => e.IdPedido === seleccionado.IdPedido)
      found.Productos[id]['IdProdProv'] = e.target.value
      setPedidos(() => copiaPedidos)
  }
  
  const handleNumEnvio = (e, pedidos, setPedidos, seleccionado) => {
        //no usa index porque se lo asigna a todos los selected
        let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
        let found = copiaPedidos.find(e => e.IdPedido === seleccionado.IdPedido)
        //found.Productos[id]['NoEnvioProv'] = e.target.value
        setPedidos(() => copiaPedidos)
  }


  const verifySelected = () => {

  }

  const handleChecked = (e, i, pedidos, setPedidos, numEnvio, fechaActual, seleccionado) => {
      // setPedidoSeleccionado(pedidos[i])
      // si no hay ningun pedido seleccionado, se debe de habilitar todos los cards para seleccionar
      let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
      let found = copiaPedidos.find(e => e.IdPedido === seleccionado.IdPedido)
      found.Productos[i].selected = e.target.checked
      found.fechaEnvio = aFechaConDiagonales(fechaActual)
      found.Productos[i].NoEnvioProv = numEnvio
      setPedidos(() => copiaPedidos)
  }

  const handleFecha = (e, pedidos, setPedidos, setFechaActual, seleccionado) => {
    setFechaActual(e.target.value)
    let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
    let found = copiaPedidos.find(e => e.IdPedido === seleccionado.IdPedido)
    found.fechaEnvio = aFechaConDiagonales(e.target.value)
    setPedidos(() => copiaPedidos)
  }

  // ask for permission
  const handleSubmit = (setModal, pedidos, seleccionado, IdEmp, headers, urlInvoiceApi, proveedor, idProveedor) => {
    if(window.navigator.onLine){
      // si presiona ok va a enviarlo, de lo contrario, sólo se desaparece el modal
      // 0 - debe haber al menos uno seleccionado
      let iterable = Object.values(pedidos).flat(Infinity).find(e => e.IdPedido === seleccionado.IdPedido)
      iterable.Productos.map(e => {
        e.Cantidad = e.CantidadSaldo
        e.NoEnvioProv = seleccionado.IdPedido
      })
    let haySeleccion = iterable.Productos.some(e => e.selected)
    if(haySeleccion){
      // 1 - los que estan seleccionados deben tener numeros de envio, fecha de envio, id y cantidad de envío
      // IdProdProv, NoEnvioProv, fechaEnvio, CantidadEntregado
      let seleccionados = iterable.Productos.filter(e => e.selected);
      let tieneCantidadEntregado = seleccionados.every(e => e.hasOwnProperty("Cantidad"));
      let tienenNoEnvioProv = seleccionados.every(e => e.hasOwnProperty("NoEnvioProv"));
      //let tienenIdProdProv = seleccionados.every(e => e.hasOwnProperty("IdProdProv"));
      //let tienenfechaEnvio = seleccionados.every(e => e.hasOwnProperty("fechaEnvio"));
      
      if(tienenNoEnvioProv && tieneCantidadEntregado){ // && tienenfechaEnvio
        agruparPedidos([iterable], setModal, IdEmp, headers, urlInvoiceApi, proveedor, idProveedor)
      }else{
        setModal({
          show:true,
          ok:false,
          msg:"Llene todos los datos de los pedidos seleccionados"
        })          
      }
    }else{
      setModal({
        show:true,
        ok:false,
        msg:"Debe seleccionar al menos un producto"
      })
    }
  }else{
    setModal({
      show:true,
      ok:false,
      msg:"Verifique su conexión a internet",
      reload:true,
    })
  }
}

const handleKeyDown = (event) => {
    if (document.activeElement.type === "number") {
      if (!`${event.target.value}${event.key}`.match(/^[0-9]*[^\W]/)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
      }
  }
}

const handleFechaActual = (e, setFechaActual) => {
    setFechaActual(e.target.value)
}

export {
    handlePedidos,
    handleIdProdProv,
    handleNumEnvio,
    handleChecked,
    handleFecha,
    handleSubmit,
    handleKeyDown,
    handleFechaActual
}